<template>
  <div id="app">
    <main class="site-main">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  components: {},
  name: "app",
  created() {
    let elem = document.getElementById("loader");
    elem.remove();
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      Vue.analytics.fbq.event("PageView", {
        content_name: to.path,
      });
      this.$ga.page({
        page: to.path,
        location: window.location.href,
      });
      // this.$ga.event({
      //   eventCategory: 'category',
      //   eventAction: 'action',
      //   eventLabel: 'label',
      //   eventValue: 123
      // })
    },
  },
  computed: {
    siteURL() {
      return window.location.host;
    },
    languageVal() {
      return localStorage.getItem("language");
    },
  },
  beforeMount() {
    // window.localStorage.getItem("CountryName");
    // if (
    //   (window.location.origin === "http://empirecinemas.me" ||
    //     window.location.origin === "https://empirecinemas.me") &&
    //   window.location.pathname !== "/iraq"
    // ) {
    //   window.localStorage.setItem("CountryName", "Iraq");
    //   let language = {
    //     lang: "eng",
    //     lang_id: 2
    //   };
    //   LanguageService.saveLanguage(language);
    //   window.location.pathname = "/iraq";
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue